import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { GroupBookingInitStepDeclaration } from "./Steps/GroupBookingInitStep";

export const GroupBookingStartupFlow = new FlowDefinition("GroupBookingFlow");

GroupBookingStartupFlow.addStep(GroupBookingInitStepDeclaration);

GroupBookingStartupFlow.setStartStep("GroupBookingInit_Step");

export const groupBookingStepDefinition = new StepDefinition({
    stepName: "GroupBookingFlow",
    stepFlow: GroupBookingStartupFlow,
    contextIsolation: false
})
